module.exports = __webpack_public_path__ + "img/05.f6ed6ad3.png";